// extracted by mini-css-extract-plugin
module.exports = {"root":"IconMenu_root__U5iB6"};